import { Component, ReactNode } from "react";
export default class VectorHeader extends Component {
  render(): ReactNode {
    return (
        <svg
          width="36"
          height="35"
          viewBox="0 0 36 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.5 17.5C35.504 18.0127 35.3481 18.5139 35.0541 18.934C34.7601 19.354 34.3425 19.672 33.8594 19.8438L23.9469 23.4484L20.3438 33.3594C20.1662 33.8378 19.8464 34.2505 19.4274 34.5418C19.0085 34.8332 18.5103 34.9894 18 34.9894C17.4897 34.9894 16.9915 34.8332 16.5726 34.5418C16.1536 34.2505 15.8338 33.8378 15.6563 33.3594L12.0516 23.4375L2.14063 19.8438C1.66218 19.6662 1.24955 19.3464 0.958163 18.9274C0.666775 18.5085 0.51059 18.0103 0.51059 17.5C0.51059 16.9897 0.666775 16.4915 0.958163 16.0726C1.24955 15.6536 1.66218 15.3338 2.14063 15.1563L12.0625 11.5516L15.6563 1.64063C15.8338 1.16218 16.1536 0.749552 16.5726 0.458163C16.9915 0.166775 17.4897 0.0105896 18 0.0105896C18.5103 0.0105896 19.0085 0.166775 19.4274 0.458163C19.8464 0.749552 20.1662 1.16218 20.3438 1.64063L23.9484 11.5625L33.8594 15.1563C34.3425 15.328 34.7601 15.646 35.0541 16.066C35.3481 16.4861 35.504 16.9873 35.5 17.5Z"
            fill="#AD28EB"
          />
        </svg>
    );
  }
}
